import type { Publication } from '~/interfaces/publication';

/**
 * Reads Swarm's premium_purchasable, falling back to premium_enabled until Swarm ships the field.
 * Drop the fallback (and this helper) once that deploy has landed.
 */
const isPremiumPurchasable = (publication?: Pick<Publication, 'premium_enabled' | 'premium_purchasable'>): boolean =>
  publication?.premium_purchasable ?? publication?.premium_enabled ?? false;

export default isPremiumPurchasable;
